(() => {
const configs = new Map();
const el = (tag, cls, text) => { const node=document.createElement(tag); if(cls)node.className=cls; if(text!==undefined)node.textContent=text; return node; };
const decode = text => {const box=document.createElement('textarea');box.innerHTML=text;return box.value};
const frameLabel = value => {
 if(!/canvas wrap/i.test(value)) return value;
 if(/^unframed/i.test(value)) return 'Stretched canvas only';
 const color=/walnut/i.test(value)?'Walnut':/oak/i.test(value)?'Light oak':/white/i.test(value)?'White':/black/i.test(value)?'Black':'';
 return color?color+' float frame · Stretched canvas':value;
};
class MaslowNativeOptions extends HTMLElement {
 async connectedCallback(){
  if(this.dataset.ready)return;this.dataset.ready='true';this.busy=false;
  this.form=this.querySelector('form');this.button=this.querySelector('[type=submit]');this.status=this.querySelector('.mno-status');
  this.variants=JSON.parse(this.querySelector('[data-mno-variants]').textContent);
  this.fees=JSON.parse(this.querySelector('[data-mno-fees]').textContent);
  this.money=n=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:this.dataset.currency||'USD'}).format(n/100);
  try{
   const url=this.dataset.configUrl;
   if(!configs.has(url))configs.set(url,fetch(url).then(r=>{if(!r.ok)throw Error('Options unavailable');return r.json()}));
   const all=await configs.get(url);this.config=all[this.dataset.handle];if(!this.config)throw Error('Options unavailable');
   this.querySelectorAll('[data-display-value]').forEach(s=>s.textContent=frameLabel(s.textContent));
   this.querySelectorAll('.mno-group').forEach(group=>{const name=group.querySelector('legend').textContent;if(name==='Canvas & frame options')group.style.order='0';else if(group.classList.contains('mno-sizes'))group.style.order='1';else group.style.order='2'});
   if(this.config.art.length)this.buildArt();
   else if(this.config.tray)this.querySelector('[data-mno-art]').append(el('p','mno-help','One double-sided art insert is included.'));
   if(this.config.personalization)this.buildPersonalization();
   this.form.addEventListener('change',event=>{this.status.hidden=true;this.update(event.target)});
   this.form.addEventListener('input',event=>{if(event.target.name==='quantity')this.update(event.target)});
   this.form.addEventListener('submit',event=>this.add(event));
   const urlId=new URL(location.href).searchParams.get('variant');
   const selected=this.variants.find(v=>String(v.id)===urlId);
   if(selected)selected.options.forEach((value,index)=>{const input=this.radios(index).find(x=>x.value===value);if(input)input.checked=true});
   this.update();
  }catch(error){this.button.textContent='Options temporarily unavailable';this.show('Please refresh the page. If options still do not load, contact us for help.')}
 }
 radios(index){return Array.from(this.querySelectorAll('input[name="mno-option-'+index+'"]'))}
 field(labelText,name,tag='input'){
  const label=el('label','mno-field',labelText),input=el(tag);
  input.name=name;input.disabled=true;input.required=true;input.maxLength=tag==='textarea'?1000:200;
  if(tag==='textarea')input.rows=3;
  label.append(input);return label;
 }
 buildArt(){
  const host=this.querySelector('[data-mno-art]');
  host.append(el('p','mno-note','Included with your tray: one double-sided art insert. Choose artwork for Side 1 and Side 2.'));
  for(const side of [1,2]){
   const details=el('details','mno-art-picker');details.open=side===1;
   const summary=el('summary',null,'Side '+side+' artwork'),chosen=el('span','mno-chosen','Choose a design');
   chosen.dataset.side=side;summary.append(chosen);details.append(summary);
   const field=el('fieldset'),legend=el('legend','visually-hidden','Side '+side+' artwork');field.append(legend);
   const grid=el('div','mno-art-grid');
   this.config.art.forEach((art,index)=>{
    const label=el('label','mno-art-choice'),input=el('input');input.type='radio';input.name='art'+side;input.value=art.name;input.required=true;
    const image=el('img');image.src=art.image;image.alt=art.name;image.width=180;image.height=180;image.loading='lazy';
    label.append(input,image,el('span',null,art.name));grid.append(label);
   });field.append(grid);details.append(field);host.append(details);
  }
  const extras=el('details','mno-extras');extras.append(el('summary',null,'Add extra art inserts'));
  extras.append(el('p','mno-help','Optional. Each extra insert is double-sided; no additional tray is included.'));
  for(const size of [12,20]){
   const key='extra'+size,fee=this.fees[key];if(!fee.id||!fee.available)continue;
   const group=el('div','mno-extra'),label=el('label','mno-extra-toggle'),check=el('input');check.type='checkbox';check.name=key;
   label.append(check,el('span',null,size+'″ × '+size+'″ insert'),el('b',null,'+ '+this.money(fee.price)));group.append(label);
   const fields=el('div','mno-extra-fields');fields.hidden=true;
   for(const side of [1,2]){
    const f=this.field('Side '+side,key+'side'+side,'select'),select=f.querySelector('select');
    select.append(new Option('Choose a design',''));this.config.art.forEach(a=>select.append(new Option(a.name,a.name)));
    fields.append(f);
   }
   group.append(fields);extras.append(group);
  }
  host.append(extras);
 }
 buildPersonalization(){
  const host=this.querySelector('[data-mno-personalization]'),field=el('fieldset','mno-personalization'),legend=el('legend',null,'Make it personal');
  field.append(legend);const choices=el('div','mno-personal-choices');
  const nameText=this.config.personalization===1?'Name and/or graduation year':'Name personalization';
  for(const [key,labelText] of [['none','No personalization'],['name',nameText],['icons','Custom icons + name']]){
   const fee=this.fees[key];if(key!=='none'&&(!fee?.id||!fee.available))continue;
   const label=el('label','mno-choice'),input=el('input');input.type='radio';input.name='personalization';input.value=key;input.checked=key==='none';
   label.append(input,el('span',null,labelText),el('b',null,key==='none'?'Included':'+ '+this.money(fee.price)));choices.append(label);
  }
  field.append(choices);
  const text=this.field(nameText,'personalizationText');text.hidden=true;text.querySelector('input').placeholder=this.config.personalization===1?'Example: Jordan Smith · Class of 2027':'Example: The Smith Family';field.append(text);
  const icons=this.field('Describe up to five hand-drawn icons','personalizationIcons','textarea');icons.hidden=true;icons.querySelector('textarea').placeholder='Places, hobbies, a major, or meaningful details. Name personalization is included.';field.append(icons);
  field.append(el('p','mno-help','Personalized orders receive a proof by email before printing. Custom icons include name personalization.'));
  host.append(field);
 }
 selectedOptions(){return Array.from(this.querySelectorAll('.mno-group')).map(g=>g.querySelector('input:checked')?.value)}
 update(target){
  const selected=this.selectedOptions();
  this.variant=this.variants.find(v=>v.options.every((value,i)=>value===selected[i]));
  this.querySelectorAll('.mno-group').forEach(g=>{
   const index=Number(g.dataset.optionIndex);
   g.querySelectorAll('input').forEach(input=>{
    const exists=this.variants.some(v=>v.available&&v.options.every((value,i)=>i===index?value===input.value:value===selected[i]));
    input.closest('label').classList.toggle('mno-unavailable',!exists);
    input.setAttribute('aria-description',exists?'':'Currently unavailable with your other selections');
   });
  });
  const kind=this.querySelector('[name=personalization]:checked')?.value||'none';
  for(const [name,show] of [['personalizationText',kind!=='none'],['personalizationIcons',kind==='icons']]){
   const input=this.querySelector('[name='+name+']');if(input){input.disabled=!show;input.closest('label').hidden=!show;input.required=name==='personalizationIcons'?show:kind==='name'}
  }
  for(const size of [12,20]){
   const check=this.querySelector('[name=extra'+size+']');if(!check)continue;
   const fields=check.closest('.mno-extra').querySelector('.mno-extra-fields');fields.hidden=!check.checked;fields.querySelectorAll('select').forEach(s=>s.disabled=!check.checked);
  }
  for(const side of [1,2]){
   const art=this.querySelector('[name=art'+side+']:checked'),chosen=this.querySelector('[data-side="'+side+'"]');
   if(chosen)chosen.textContent=art?art.value:'Choose a design';
  }
  const quantity=this.querySelector('[name=quantity]');
  if(this.variant){
   quantity.min=this.variant.minimum;quantity.step=this.variant.increment;
   if(this.variant.maximum)quantity.max=this.variant.maximum;else quantity.removeAttribute('max');
   if(Number(quantity.value)<this.variant.minimum)quantity.value=this.variant.minimum;
  }
  let unit=this.variant?.price||0;
  if(kind!=='none')unit+=this.fees[kind].price;
  for(const key of ['extra12','extra20'])if(this.querySelector('[name='+key+']:checked'))unit+=this.fees[key].price;
  this.querySelector('[data-mno-total]').textContent=this.variant?this.money(unit*(Number(quantity.value)||1)):'Unavailable combination';
  this.button.disabled=this.busy||!this.variant?.available;this.button.textContent=this.variant?.available?'Add to cart':this.variant?'Sold out':'Choose available options';
  if(this.variant){
   const root=this.closest('product-info')||this.closest('section')||document;
   root.querySelectorAll('[id^="price-"] .price-item--regular').forEach(p=>p.textContent=this.money(this.variant.price));
   if(target?.name?.startsWith('mno-option-')){
    const url=new URL(location.href);url.searchParams.set('variant',this.variant.id);history.replaceState({},'',url);
   }
   this.previewImage=this.variant.image;
   const trayPhotos=this.config.photos['0']||[];
   if(this.config.tray){const value=selected[0],photo=trayPhotos.find(p=>decode(p.name)===value);if(photo?.image)this.previewImage=photo.image}
   if(target?.name?.startsWith('mno-option-')||!this.photoInitialized){
    const gallery=root.querySelector('media-gallery');
    const mediaId=this.variant.mediaId;
    const item=mediaId&&gallery?.querySelector('[data-media-id="'+this.dataset.section+'-'+mediaId+'"]');
    if(item&&!this.config.tray){
     if(target?.name?.startsWith('mno-option-')&&typeof gallery.setActiveMedia==='function')gallery.setActiveMedia(item.dataset.mediaId,true);
    }else{
     const first=gallery?.querySelector('.product__media-list > li:first-child img');
     if(first&&this.previewImage){first.src=this.previewImage;first.removeAttribute('srcset');first.alt=this.variant.title;
      const opener=first.closest('li')?.querySelector('modal-opener');
      const modalId=opener?.querySelector('[data-media-id]')?.dataset.mediaId;
      const modal=modalId?root.querySelector('product-modal [data-media-id="'+modalId+'"] img'):root.querySelector('product-modal img');
      if(modal){modal.src=this.previewImage;modal.removeAttribute('srcset')}
     }
    }
    this.photoInitialized=true;
   }
  }
 }
 show(text){this.status.textContent=text;this.status.hidden=false}
 async add(event){
  event.preventDefault();if(this.busy||!this.variant?.available)return;
  const invalid=Array.from(this.form.elements).find(x=>x.willValidate&&!x.validity.valid);
  if(invalid){let parent=invalid.parentElement;while(parent&&parent!==this.form){if(parent.tagName==='DETAILS')parent.open=true;parent=parent.parentElement}invalid.reportValidity();invalid.focus();return}
  const qty=Number(this.querySelector('[name=quantity]').value),group=crypto.randomUUID();
  const props={_maslow_configuration:group,_maslow_preview_image:this.previewImage};
  for(const side of [1,2]){const art=this.querySelector('[name=art'+side+']:checked');if(art)props['Side '+side+' artwork']=art.value}
  const items=[{id:this.variant.id,quantity:qty,properties:props}];
  const child=(key,properties)=>{const fee=this.fees[key];if(!fee?.id||!fee.available)throw Error('This extra is currently unavailable.');items.push({id:fee.id,parent_id:this.variant.id,quantity:qty,properties:{...properties,_maslow_configuration:group}})};
  try{
   for(const size of [12,20]){
    const key='extra'+size;if(!this.querySelector('[name='+key+']:checked'))continue;
    const one=this.querySelector('[name='+key+'side1]').value,two=this.querySelector('[name='+key+'side2]').value;
    child(key,{'Side 1 artwork':one,'Side 2 artwork':two,_maslow_preview_image:this.config.art.find(a=>a.name===one)?.image||''});
   }
   const kind=this.querySelector('[name=personalization]:checked')?.value||'none';
   if(kind!=='none'){
    const details={'For artwork':this.dataset.productTitle||this.dataset.handle,'Name / graduation year':this.querySelector('[name=personalizationText]').value.trim(),_maslow_preview_image:this.previewImage};
    if(kind==='icons')details['Custom icons']=this.querySelector('[name=personalizationIcons]').value.trim();
    child(kind,details);
   }
   this.busy=true;this.button.disabled=true;this.button.textContent='Adding…';this.status.hidden=true;
   const root=window.Shopify?.routes?.root||'/';
   const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-icon-bubble']})});
   const result=await response.json();if(!response.ok||result.status)throw Error(result.description||result.message||'Could not add these items.');
   const bubble=document.getElementById('cart-icon-bubble');
   if(bubble&&result.sections?.['cart-icon-bubble'])bubble.innerHTML=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section')?.innerHTML||result.sections['cart-icon-bubble'];
   this.show('Added to your cart. Your artwork selections and any paid extras are listed together.');
   const link=el('a','mno-cart-link','View your cart →');link.href=root+'cart';link.target='_blank';link.rel='noopener';this.status.append(link);this.status.focus();
  }catch(error){this.show((error.message||'Something went wrong.')+' Please check your cart before trying again.');this.status.focus()}
  finally{this.busy=false;this.update()}
 }
}
if(!customElements.get('maslow-native-options'))customElements.define('maslow-native-options',MaslowNativeOptions);
})();